export const togglePrincipalPayoffSwitch = (bool) => {
    return {
        type: "SET_PRINCIPAL_PAYOFF_SWITCH",
        switch: bool,
    }
}


// WEBPACK FOOTER //
// ./src/actions/payoffCheck.actions.js